// Global mutations
export const CLEAR = 'CLEAR';
export const SET_ITEMS = 'SET_ITEMS';

// Auth mutations
export const SET_USER = 'SET_USER';
export const SET_FORM = 'SET_FORM';
export const UPDATE_USER = 'UPDATE_USER';
